import Settings from "settings";
import { useHelloSign } from "services/hellosign";

/**
 * HelloSign embedded client configured for property contract flows (same as add-property wizard).
 */
export const usePropertyContractHelloSign = (): [
  (iframeUrl: string) => Promise<{ signatureId: string }>,
] =>
  useHelloSign({
    testMode: Settings.env !== "production",
    clientId: Settings.hellosign_client_id || "",
    metadata: {},
  });

type OpenEmbeddedOptions<T extends { signUrl: string }> = {
  open: (url: string) => Promise<{ signatureId: string }>;
  cancelIfNeeded?: () => Promise<void>;
  prepareAndGetSignUrl: () => Promise<T>;
};

/**
 * Shared flow: optional cancel, resolve embedded sign URL, open HelloSign modal.
 * Used by supervisor self-sign (create embedded request) and settings "Sign now"
 * (sign URL mutation).
 */
export const openEmbeddedPropertyContractSign = async <T extends { signUrl: string }>(
  options: OpenEmbeddedOptions<T>,
): Promise<T> => {
  if (options.cancelIfNeeded) {
    await options.cancelIfNeeded();
  }
  const result = await options.prepareAndGetSignUrl();
  if (!result.signUrl?.trim()) {
    throw new Error("Unable to open signing flow");
  }
  await options.open(result.signUrl);
  return result;
};
